
import JsonFetch from '../helpers/json-fetch';
import ServerValidation from '../helpers/server-validation';

class Actions {

  static async bulk(requests, store, requestType, responseType, timeout = 0) {
    // https://github.com/hapijs/bassmaster
    const request = {
      method: 'POST',
      url: '/v1/batch',
      data: {
        requests,
      },
    };

    return await this.makeRequest(request, store, requestType, responseType, timeout);
  }

  static async get(url, query, store, requestType, responseType, timeout = 0) {

    const request = { method: 'GET', url, query };

    return await this.makeRequest(request, store, requestType, responseType, timeout);
  }

  static async put(url, data, store, requestType, responseType, timeout = 0) {

    const request = { method: 'PUT', url, data };

    return await this.makeRequest(request, store, requestType, responseType, timeout);
  }

  static async patch(url, data, store, requestType, responseType, timeout = 0) {

    const request = { method: 'PATCH', url, data };

    return await this.makeRequest(request, store, requestType, responseType, timeout);
  }

  static async post(url, data, store, requestType, responseType, timeout = 0) {

    const request = { method: 'POST', url, data };

    return await this.makeRequest(request, store, requestType, responseType, timeout);
  }

  static async delete(url, query, store, requestType, responseType, timeout = 0) {

    const request = { method: 'DELETE', url, query };

    return await this.makeRequest(request, store, requestType, responseType, timeout);
  }

  static async makeRequest(request, store, requestType, responseType, timeout = 0) {

    store.dispatch({ type: requestType, request });

    const responseAction = { type: responseType };

    try {
      request.timeout = timeout;
      responseAction.data = await JsonFetch(request);
    }
    catch (error) {
      console.warn(`API: ${request.method} ${request.url}:`, error);

      responseAction.error = error;
    }

    responseAction.validation = ServerValidation(responseAction.error);

    store.dispatch(responseAction);

    return responseAction;
  }

  static async postFile(url, formData, store, requestType, responseType) {

    const request = { method: 'POST', url, formData };

    return await this.makeRequest(request, store, requestType, responseType);
  }

  static validateReturnURL(url){
    //list of hard coded returnURL paths to avoid security exploits, factor /account-mobile/ paths
    return url.indexOf('returnURL') === -1  && (url.indexOf('/account') === 0 || url.indexOf('/admin') === 0);
  }
}


export default Actions;



// WEBPACK FOOTER //
// ./client/actions/api.js